export default {
    indexTerms:            { method: 'get',    url: 'terms' },
    createTerm:            { method: 'post',   url: 'terms' },
    updateTerm:            { method: 'put',    url: 'terms/{id}' },
    destroyTerm:           { method: 'delete', url: 'terms/{id}' },
    indexTermOptions:      { method: 'get',    url: 'terms/options' },
    signatureProviders:    { method: 'get',    url: 'terms/signature-providers' },
}